const store = window.localStorage;

function setLocalStoreItem(key, value) {
  let stringVal;
  try {
    stringVal = JSON.stringify(value);
  } catch (err) {
    throw Error(`unable to set ${key} to ${value}`);
  }

  store.setItem(key, stringVal);
}

function getLocalStoreItem(key) {
  const strValue = store.getItem(key);
  if (typeof strValue === "string") {
    return JSON.parse(strValue);
  }
  return null;
}

function removeLocalStoreItem(key) {
  store.removeItem(key);
}

export default {
  setLocalStoreItem,
  getLocalStoreItem,
  removeLocalStoreItem
};
